var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-2",attrs:{"flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("event.upcomingEvents")))]),_c('event-public-calendar',{ref:"calendar",attrs:{"ownerId":_vm.userId,"providedStart":(_vm.ym + "-01")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }